import {
  Create,
  SimpleForm,
  TextInput,
  PasswordInput,
  SelectInput,
  BooleanInput,
  required,
  email,
  minLength,
  TopToolbar,
  ListButton,
} from 'react-admin';

const UserCreateActions = () => (
  <TopToolbar>
    <ListButton />
  </TopToolbar>
);

export const UserCreate: React.FC = () => (
  <Create actions={<UserCreateActions />}>
    <SimpleForm>
      <TextInput type="email" source="email" validate={[required(), email()]} />
      <PasswordInput source="password" validate={[required(), minLength(6)]} />
      <TextInput source="firstName" />
      <TextInput source="lastName" />
      <SelectInput
        source="role"
        choices={[
          { id: 'ADMIN', name: 'Admin' },
          { id: 'CUSTOMER', name: 'Customer' },
        ]}
        validate={[required()]}
        defaultValue="CUSTOMER"
      />
      <BooleanInput source="isActive" defaultValue={true} />
    </SimpleForm>
  </Create>
);
